export default __webpack_public_path__ + "static/media/kanta_approval.1913b113.png";